/*
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { register } from 'swiper/element/bundle';

register();

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
*/
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { register } from 'swiper/element/bundle';
import { RolePermissionService } from './app/shared/services/role-permission.service';
import { AuthService } from './app/shared/services/auth.service';
import { GlobalService } from './app/shared/services/global.service';
import { VexLayoutService } from '@vex/services/vex-layout.service';


register();

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    ...appConfig.providers, // keep existing providers
    RolePermissionService,
    AuthService,
    GlobalService,
    VexLayoutService
  ]
}).catch((err) => console.error(err));
